import MobileAppNotLiveBanner from './MobileAppNotLiveBanner';

export default {
  MobileAppNotLiveBanner,
};
